import { render, staticRenderFns } from "./OptometryHistoryForm.vue?vue&type=template&id=9d48098a&"
import script from "./OptometryHistoryForm.vue?vue&type=script&lang=js&"
export * from "./OptometryHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports